import { SectionCard, SkeletonLoader } from '../yeni-design/primitives';

/**
 * Bir blogun sorgusu SURERKEN onun YERINI TUTAN kabuk.
 *
 * NEDEN: bloklar eskiden yuklenirken `null` donuyordu -- ekran bos aciliyor,
 * sonra her sorgu kendi zamaninda donunce blok ANIDEN beliriyor ve altindaki
 * her sey asagi kayiyordu. Olculdu (2026-08-27, Gizova, firma 7): blok
 * sorgulari 0,74 sn ile 12,5 sn arasinda donuyor (en yavasi 990041), yani
 * kayma 12 saniyeye yayiliyordu. Kullanici bir blogu okumaya baslayip
 * ortasinda yerinden oynatilabiliyordu.
 *
 * Bu kabuk `yukseklik` kadar yer AYIRIR, yani sayfa duzeni ilk karede
 * son halini alir ve hicbir blok digerini itmez. Sorgu donunce icerik ayni
 * yere oturur.
 *
 * 🔴 `yukseklik` KABA olmali, birebir degil: blogun gercek yuksekligi veriye
 * gore degisir (ör. SubeBlok'ta lokasyon sayisi). Amac kaymayi SIFIRLAMAK
 * degil, 12 saniyelik zipklamayi bir kez ve kucuk bir duzeltmeye indirmek --
 * birebir tutturma iddiasi veri degisince sessizce yalan olurdu.
 */
export function BlokIskeleti({
  testid,
  baslik,
  altBaslik,
  yukseklik,
  satir = 4,
}: {
  testid: string;
  baslik: string;
  altBaslik?: string;
  /** Govde icin ayrilan asgari yukseklik (px). */
  yukseklik: number;
  satir?: number;
}) {
  return (
    <div data-testid={testid} data-yukleniyor="true">
      <SectionCard title={baslik} subtitle={altBaslik}>
        {/* aria-busy: ekran okuyucu "burada bir sey var ama henuz hazir degil"
            diyebilsin. Bos bir kutu sessizce atlanirdi. */}
        <div style={{ minHeight: yukseklik }} aria-busy="true" aria-live="polite">
          <SkeletonLoader lines={satir} lineClass="h-4" />
        </div>
      </SectionCard>
    </div>
  );
}
